module.exports = __webpack_public_path__ + "static/media/gallery-background-image.ac5e06a1.png";